var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5838 21.9756C59.5838 9.85823 49.7256 0 37.6083 0C8.45456 1.20727 8.46284 42.7486 37.6083 43.9511C49.726 43.9511 59.5838 34.0929 59.5838 21.9756Z",
    fill: "#FDEAE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2247 88.3232V81.5636C73.1526 31.6531 2.05355 31.6917 0 81.5632V88.3228C0 91.5911 2.64969 94.2408 5.91801 94.2408H69.3067C72.575 94.2412 75.2247 91.5915 75.2247 88.3232Z",
    fill: "#FDEAE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.361 21.9756C186.361 9.85823 176.503 0 164.386 0C135.232 1.20727 135.24 42.7486 164.386 43.9511C176.503 43.9511 186.361 34.0929 186.361 21.9756Z",
    fill: "#FDEAE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.389 43.9512C143.65 43.9512 126.777 60.8242 126.777 81.5633V88.3229C126.777 91.5912 129.427 94.2409 132.695 94.2409H196.084C199.352 94.2409 202.002 91.5912 202.002 88.3229V81.5633C202.002 60.8242 185.129 43.9512 164.389 43.9512Z",
    fill: "#FDEAE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1888 107.34C37.1888 106.918 37.1967 106.498 37.2046 106.078H25.3685C24.8975 131.446 37.1951 154.365 56.2385 168.323C57.9397 164.711 60.0655 161.338 62.551 158.267C47.1453 146.618 37.1888 128.143 37.1888 107.34Z",
    fill: "#FDEAE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8854 49.1041C90.6257 41.7326 111.378 41.7326 127.119 49.1041C129.925 45.8851 133.141 43.0318 136.684 40.6259C115.736 28.8297 86.2681 28.8301 65.3203 40.6259C68.8632 43.0318 72.0787 45.8855 74.8854 49.1041Z",
    fill: "#FDEAE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.788 106.078C165.247 127.22 155.161 146.425 139.441 158.267C141.927 161.338 144.052 164.711 145.754 168.323C164.797 154.367 177.095 131.445 176.624 106.078H164.788Z",
    fill: "#FDEAE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.978 129.736C122.978 117.619 113.12 107.76 101.003 107.76C71.8491 108.968 71.8574 150.509 101.003 151.712C113.12 151.712 122.978 141.854 122.978 129.736Z",
    fill: "#FDEAE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.007 151.712C80.2672 151.712 63.3945 168.585 63.3945 189.324V196.084C63.3945 199.352 66.0442 202.002 69.3125 202.002H132.701C135.97 202.002 138.619 199.352 138.619 196.084V189.324C138.619 168.585 121.746 151.712 101.007 151.712Z",
    fill: "#FDEAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord16);
export default __webpack_public_path__ + "static/media/accord_16.fb8635f691422a888064fb538a301ae9.svg";
export { ForwardRef as ReactComponent };